export default {
      id: "persons-usage",
      viewBox: "0 0 26 24",
      url: __webpack_public_path__ + "svgsprite.svg#persons",
      toString: function () {
        return this.url;
      }
    }